import { render, staticRenderFns } from "./OrganizacaoApi.vue?vue&type=template&id=cd3e45dc&scoped=true&"
import script from "./OrganizacaoApi.vue?vue&type=script&lang=js&"
export * from "./OrganizacaoApi.vue?vue&type=script&lang=js&"
import style0 from "./OrganizacaoApi.vue?vue&type=style&index=0&id=cd3e45dc&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd3e45dc",
  null
  
)

export default component.exports